/* 
   Basic client-side media protection.
   This does not make media impossible to download,
   it only discourages casual saving.
*/
// custom
// Inject CSS to prevent dragging images/videos
(function () {
  const style = document.createElement('style');
  style.innerHTML = `
    img, video {
      -webkit-user-drag: none;
      user-drag: none;
      -webkit-touch-callout: none;
    }
  `;
  document.head.appendChild(style);
})();

// Disable right-click everywhere on the page
document.addEventListener('contextmenu', function (e) {
  e.preventDefault();
});

// Prevent drag start on images/videos
document.addEventListener('dragstart', function (e) {
  const tag = e.target.tagName;
  if (tag === 'IMG' || tag === 'VIDEO') {
    e.preventDefault();
  }
});

// Block common save/view shortcuts
// Block common save/view shortcuts and devtools
document.addEventListener('keydown', function (e) {

  const key = e.key.toLowerCase();

  // Prevent Ctrl+S (save page)
  if (e.ctrlKey && key === 's') {
    e.preventDefault();
  }

  // Prevent Ctrl+U (view source)
  if (e.ctrlKey && key === 'u') {
    e.preventDefault();
  }

  // Prevent Ctrl+Shift+I (devtools)
  if (e.ctrlKey && e.shiftKey && key === 'i') {
    e.preventDefault();
  }

  // Prevent Ctrl+Shift+C (inspect element)
  if (e.ctrlKey && e.shiftKey && key === 'c') {
    e.preventDefault();
  }

  // Prevent Ctrl+Shift+J (console)
  if (e.ctrlKey && e.shiftKey && key === 'j') {
    e.preventDefault();
  }

  // Prevent F12
  if (e.key === 'F12') {
    e.preventDefault();
  }
});

// Remove video download option if browser supports it
document.addEventListener('DOMContentLoaded', function () {
  const videos = document.querySelectorAll('video');

  videos.forEach(function (video) {
    video.setAttribute('controlsList', 'nodownload');
  });
});